module.exports = __webpack_public_path__ + "media/images/home-clients-2db6526d08f0f532d440145c45f324ab.png";